import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  // Auto scroll when route changes
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname]);

  // Show button after scrolling down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Click handler
  const handleScrollTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <>
      {visible && (
        <button
          onClick={handleScrollTop}
          className="fixed bottom-6 cursor-pointer w-12 h-12 right-6 z-50 p-3 rounded-full text-white bg-[#05326D] shadow-lg hover:bg-[#04224a] transition"
          aria-label="Scroll to top"
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="10" viewBox="0 0 24 18" className="rotate-90">
                <path id="Icon_Arrow_Left_Active" d="M9,0,0,9l9,9,2.1-2.175L5.775,10.5H24v-3H5.775L11.1,2.175Z" transform="translate(0 0)" fill="#fff"/>
            </svg>
            <span className="text-xs">Top</span>
        </button>
      )}
    </>
  );
}
